// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

section p[data-reveal="out"],
section img[data-reveal="out"],
section h2[data-reveal="out"],
section h3[data-reveal="out"] {
  opacity: 0;
  transform: translate3d(0, 14px, 0);
  transition: opacity 650ms ease, transform 650ms ease;
  will-change: opacity, transform;
}

section p[data-reveal="in"],
section img[data-reveal="in"],
section h2[data-reveal="in"],
section h3[data-reveal="in"] {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

@media (prefers-reduced-motion: reduce) {
  section p[data-reveal="out"],
  section img[data-reveal="out"],
  section h2[data-reveal="out"],
  section h3[data-reveal="out"],
  section p[data-reveal="in"],
  section img[data-reveal="in"],
  section h2[data-reveal="in"],
  section h3[data-reveal="in"] {
    transition: none;
    transform: none;
    opacity: 1;
  }
}

/* Pulse suave */
@keyframes pulseSoft {
  0% {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
    transform: scale(1);
  }
  4% {
    box-shadow: 0 12px 22px rgba(0, 0, 0, 0.45);
    transform: scale(1.015);
  }
  8% {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
    transform: scale(1);
  }
  100% {
    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);
  }
}

/* Shine timing */
@keyframes shine {
  0% {
    left: -120%;
  }
  5% {
    left: 120%;
  }
  100% {
    left: 120%;
  }
}


#Accion-Hero .BGNaranja {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  color: #ffffff;
  font-weight: 600;
  font-size: 18px;
  text-decoration: none;
  border-radius: 8px;
  letter-spacing: 0.3px;
  position: relative;
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;

  /* Animación automática */
  animation: pulseSoft 12s ease-in-out infinite;
}

/* HOVER */
#Accion-Hero .BGNaranja:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 10px black;
}

/* Glow hover */
#Accion-Hero .BGNaranja::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255, 255, 255, 0.35),
    transparent
  );
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

#Accion-Hero::before {
  transform: translateX(100%);
}

/* Shine automático cada 12s */
#Accion-Hero .BGNaranja::after {
  content: "";
  position: absolute;
  top: 0;
  left: -120%;
  width: 120%;
  height: 100%;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255, 255, 255, 0.25),
    transparent
  );
  animation: shine 12s ease-in-out infinite;
}

/* Click */
#Accion-Hero .BGNaranja:active {
  transform: scale(0.97);
}


/* HOVER */
#Accion-Hero .BGNaranja:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 10px black;
}

/* Glow hover */
#Accion-Hero .BGNaranja::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    120deg,
    transparent,
    rgba(255, 255, 255, 0.35),
    transparent
  );
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

#Accion-Hero .BGNaranja:hover::before {
  transform: translateX(100%);
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;EAIE,UAAU;EACV,kCAAkC;EAClC,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;;;;EAIE,UAAU;EACV,+BAA+B;AACjC;;AAEA;EACE;;;;;;;;IAQE,gBAAgB;IAChB,eAAe;IACf,UAAU;EACZ;AACF;;AAEA,gBAAgB;AAChB;EACE;IACE,yCAAyC;IACzC,mBAAmB;EACrB;EACA;IACE,2CAA2C;IAC3C,uBAAuB;EACzB;EACA;IACE,yCAAyC;IACzC,mBAAmB;EACrB;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,uDAAuD;;EAEvD,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA,UAAU;AACV;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,yCAAyC;AAC3C;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;;AAGA,UAAU;AACV;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA,eAAe;AACf;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\nsection p[data-reveal=\"out\"],\nsection img[data-reveal=\"out\"],\nsection h2[data-reveal=\"out\"],\nsection h3[data-reveal=\"out\"] {\n  opacity: 0;\n  transform: translate3d(0, 14px, 0);\n  transition: opacity 650ms ease, transform 650ms ease;\n  will-change: opacity, transform;\n}\n\nsection p[data-reveal=\"in\"],\nsection img[data-reveal=\"in\"],\nsection h2[data-reveal=\"in\"],\nsection h3[data-reveal=\"in\"] {\n  opacity: 1;\n  transform: translate3d(0, 0, 0);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  section p[data-reveal=\"out\"],\n  section img[data-reveal=\"out\"],\n  section h2[data-reveal=\"out\"],\n  section h3[data-reveal=\"out\"],\n  section p[data-reveal=\"in\"],\n  section img[data-reveal=\"in\"],\n  section h2[data-reveal=\"in\"],\n  section h3[data-reveal=\"in\"] {\n    transition: none;\n    transform: none;\n    opacity: 1;\n  }\n}\n\n/* Pulse suave */\n@keyframes pulseSoft {\n  0% {\n    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);\n    transform: scale(1);\n  }\n  4% {\n    box-shadow: 0 12px 22px rgba(0, 0, 0, 0.45);\n    transform: scale(1.015);\n  }\n  8% {\n    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);\n    transform: scale(1);\n  }\n  100% {\n    box-shadow: 0 6px 14px rgba(0, 0, 0, 0.3);\n  }\n}\n\n/* Shine timing */\n@keyframes shine {\n  0% {\n    left: -120%;\n  }\n  5% {\n    left: 120%;\n  }\n  100% {\n    left: 120%;\n  }\n}\n\n\n#Accion-Hero .BGNaranja {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 24px;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 18px;\n  text-decoration: none;\n  border-radius: 8px;\n  letter-spacing: 0.3px;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.25s ease, box-shadow 0.25s ease;\n\n  /* Animación automática */\n  animation: pulseSoft 12s ease-in-out infinite;\n}\n\n/* HOVER */\n#Accion-Hero .BGNaranja:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 10px black;\n}\n\n/* Glow hover */\n#Accion-Hero .BGNaranja::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    120deg,\n    transparent,\n    rgba(255, 255, 255, 0.35),\n    transparent\n  );\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n#Accion-Hero::before {\n  transform: translateX(100%);\n}\n\n/* Shine automático cada 12s */\n#Accion-Hero .BGNaranja::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -120%;\n  width: 120%;\n  height: 100%;\n  background: linear-gradient(\n    120deg,\n    transparent,\n    rgba(255, 255, 255, 0.25),\n    transparent\n  );\n  animation: shine 12s ease-in-out infinite;\n}\n\n/* Click */\n#Accion-Hero .BGNaranja:active {\n  transform: scale(0.97);\n}\n\n\n/* HOVER */\n#Accion-Hero .BGNaranja:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 10px black;\n}\n\n/* Glow hover */\n#Accion-Hero .BGNaranja::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    120deg,\n    transparent,\n    rgba(255, 255, 255, 0.35),\n    transparent\n  );\n  transform: translateX(-100%);\n  transition: transform 0.6s ease;\n}\n\n#Accion-Hero .BGNaranja:hover::before {\n  transform: translateX(100%);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
